import React, { Component } from 'react'
import { Row, Col, Divider } from 'antd'
import { getRolename } from '../../lib/AuthUtils'
import SearchBox from '../common/SearchBox'

class CatalogItemDefault extends Component {
  render() {
    const { auth, t, isMobile } = this.props
    const name =
      getRolename(auth) === 'cliente'
        ? auth.user.cliente.nombre
        : getRolename(auth) === 'vendedor' && auth.user.vendedor
          ? auth.user.vendedor.nombre
          : auth.user.username

    return (
      <Col className='item-default-content'>
        <Row style={{ height: '50%' }}>
          {isMobile ? (
            <>
              <Col span={24} className='title-content' style={{ marginTop: '35px' }}>
                {t('Welcome')} <span className='title-content-name'>{name}</span>
              </Col>
            </>
          ) : (
            <>
              <Col span={24} className='title-content' style={{ marginTop: '35px' }}>
                {t('Welcome')} <Divider className='welcome-divider' type='vertical' />{' '}
                <span className='title-content-name'>{name}</span>
              </Col>
              <Col span={24} className='catalog-search-bar-main mt-3'>
                <div className='catalog-search-bar-search'>
                  <SearchBox catalogFilter submitOnKeys={[13]} autoFocus={true}></SearchBox>
                </div>
              </Col>
            </>
          )}
        </Row>
      </Col>
    )
  }
}

export default CatalogItemDefault
